import theme, {themeColors} from '../../theme/Theme';

export const useHandoverStyles = () => ({
  wrapper: {
    background: 'white',
    marginBottom: theme.spacing(7),
  },
  wrapperValid: {},
  wrapperNotValid: {},
  fullHeight: {height: '100%', flex: 1},

  title: {
    borderLeft: `4px solid ${themeColors.green}`,
    marginBottom: theme.spacing(1),
    display: 'flex',
    justifyContent: 'flex-start',
    gap: 10,
    alignItems: 'center',
    backgroundColor: theme.palette.grey[100],
    paddingTop: theme.spacing(0.5),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(0.5),
    textDecoration: 'none',
    color: theme.palette.primary.main,
  },
  titleButton: {
    marginLeft: 'auto',
  },
  titleNotValid: {
    color: themeColors.red,
    borderLeft: `4px solid ${themeColors.red}`,
    backgroundColor: themeColors.lightPink,
  },
  pageTitle: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  wrapperInner: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  dialog: {
    backgroundColor: theme.palette.grey[100],
  },
});
